<form class="form-control-wrapper" [formGroup]="passwordBlockFormGroup">
    <mat-form-field hideRequiredMarker>
        <mat-label>
            {{ 'PARTY.CASHIER.web.deposit.cc.password.label' | translate }}
        </mat-label>
        <input
            type="password"
            id="payerPassword"
            name="payerPassword"
            matInput
            formControlName="payerPassword"
            class="form-control"
            (input)="onPasswordChange()"
            onpaste="return false;"
            ondrop="return false;" />
        @if (passwordBlockFormGroup?.get('payerPassword')?.touched || passwordBlockFormGroup?.get('payerPassword')?.dirty) {
            <mat-error>
                @if (passwordBlockFormGroup?.get('payerPassword')?.hasError('required')) {
                    <span>{{ 'PARTY.CASHIER.web.deposit.cc.password.required' | translate }} </span>
                }
                @if (passwordBlockFormGroup?.get('payerPassword')?.hasError('minlength')) {
                    <span>{{ 'PARTY.CASHIER.web.deposit.cc.password.invalid' | translate }} </span>
                }
                @if (passwordBlockFormGroup?.get('payerPassword')?.hasError('maxlength')) {
                    <span>{{ 'PARTY.CASHIER.web.deposit.cc.password.invalid' | translate }} </span>
                }
            </mat-error>
        }
    </mat-form-field>

    @if (
        !(
            passwordBlockFormGroup?.get('payerPassword')?.valid ||
            passwordBlockFormGroup?.get('payerPassword')?.touched ||
            passwordBlockFormGroup?.get('payerPassword')?.dirty
        )
    ) {
        <span
            class="theme-info-i info-icon"
            matTooltipClass="tooltip-content"
            matTooltip="{{ 'PARTY.CASHIER.web.imp.text' | translate }} : {{ 'PARTY.CASHIER.web.passwordinfo.text' | translate }}"></span>
    }
</form>
